module.exports = __webpack_public_path__ + "static/media/Staff Illustration.86b8f249.svg";